import { createTheme, Theme } from "@mui/material";
import { components, palette, typography } from "./components";

const darkTypography = {
  ...typography,
  cardTitle: { ...typography.cardTitle, color: "#BABBBD" },
  cardSectionTitle: { ...typography.cardSectionTitle, color: "#BABBBD" },
  cardBodyHeader: { ...typography.cardBodyHeader, color: "#BABBBD" },
  cardBodyRegular: { ...typography.cardBodyRegular, color: "#989A9C" },
  navBarGroupTitle: { ...typography.navBarGroupTitle, color: "#989A9C" },
  navBarItem: { ...typography.navBarItem, color: "#BABBBD" },
  navBarItemSelected: { ...typography.navBarItemSelected, color: "#FFFFFF" },
  activityTitle: { ...typography.activityTitle, color: "#BABBBD" },
  activitySubtitle: { ...typography.activitySubtitle, color: "#989A9C" },
  chatMessageBody: { ...typography.chatMessageBody, color: "#BABBBD" },
  chatSender: { ...typography.chatSender, color: "#989A9C" },
  chatTimeStamp: { ...typography.chatTimeStamp, color: "#989A9C" },
  formInput: { ...typography.formInput, color: "#BABBBD" },
} as Theme["typography"];

export const darkTheme = createTheme({
  palette: {
    ...palette,
    mode: "dark",
    background: {
      default: "#131314",
      paper: "#2A2B2D",
    },
    primary: {
      ...palette.primary,
      main: "#425CC7",
      dark: "#7F8FA6",
    },
    text: {
      primary: "#BABBBD",
      secondary: "#989A9C",
    },
    divider: "#3A3C3F",
  },
  typography: darkTypography,
  components: {
    ...components,
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "1rem",
          background: "#2A2B2D",
          boxShadow: "none",
          border: "1px solid #000000",
          paddingLeft: 0,
          paddingRight: 0,
          paddingBottom: "0rem",
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #8080801f",
          paddingLeft: "1rem",
          paddingRight: "1rem",
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          ...theme.typography.formInput,
          lineHeight: "2.75rem",
          padding: ".875rem",
          paddingTop: ".5rem",
          paddingBottom: ".5rem",
          columnGap: ".5rem",
          marginTop: ".75rem",
          textTransform: "none",
          background: "#2A2B2D",
          border: "1px solid #3A3C3F",
          borderRadius: ".75rem",
          "& input::placeholder, & textarea::placeholder": {
            color: "#99A5B8",
            opacity: 1,
          },
        }),
      },
    },
    MuiButton: {
      ...components.MuiButton,
      styleOverrides: {
        ...components.MuiButton?.styleOverrides,
        outlinedPrimary: ({ theme }) => ({
          ...theme.typography.button,
          fontWeight: 500,
          lineHeight: "1.5rem",
          paddingLeft: "1rem",
          paddingBottom: ".75rem",
          color: "#A0ADE3",
          border: "1px solid #425CC7",
          backgroundColor: "rgba(66, 92, 199, 0.30)",
        }),
      },
    },
    MuiIconButton: {
      ...components.MuiIconButton,
      styleOverrides: {
        root: {
          padding: ".5rem",
          borderRadius: ".75rem",
          border: "1px solid #4A4C4F",
          boxShadow: "none",
        },
      },
    },
  },
});
